// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"10adbc99","8":"debab516","71":"434fc3fb","105":"6dfd2c54","181":"0c09a62e","350":"292cc34f","501":"b615f190","519":"3f647d58","527":"e8174b1d","597":"ee875ccd","614":"ac888100","672":"94a4cc29","865":"eda28070"}[chunkId] + ".chunk.js";
};